export const formatters = {
  formatCurrency: (amount: number | string): string => {
    const num = typeof amount === 'string' ? parseFloat(amount.replace('$', '')) : amount
    return `$${num.toFixed(2)}`
  },

  formatTime: (minutes: number): string => {
    if (minutes < 60) return `${minutes}m ago`
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60
    return mins > 0 ? `${hours}h ${mins}m ago` : `${hours}h ago`
  },

  formatDate: (date: string | Date): string => {
    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  },

  formatPercentage: (value: number): string => {
    return `${value > 0 ? '+' : ''}${value.toFixed(0)}%`
  },

  formatDuration: (seconds: number | null): string => {
    if (seconds == null || seconds < 0) return '--:--'
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  },

  formatConfidence: (confidence: number | null): string | null => {
    if (confidence == null) return null
    return `${Math.round(confidence * 100)}%`
  },
}

export function containsDevanagari(text: string): boolean {
  return /[\u0900-\u097F]/.test(text)
}

export function formatRelative(input: string | Date | null | undefined): string {
  if (!input) return '\u2014'
  const date = typeof input === 'string' ? new Date(input) : input
  const ms = date.getTime()
  if (!Number.isFinite(ms)) return '\u2014'
  const diffSec = Math.round((Date.now() - ms) / 1000)
  if (diffSec < 5) return 'just now'
  if (diffSec < 60) return `${diffSec}s ago`
  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `${diffMin}m ago`
  const diffHr = Math.round(diffMin / 60)
  if (diffHr < 24) return `${diffHr}h ago`
  const diffDay = Math.round(diffHr / 24)
  if (diffDay < 7) return `${diffDay}d ago`
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
